<template>
  <svg
    v-once
    v-html="src" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/src/components/SvgComponent.vue